import Vue from 'vue';
import VueRouter from 'vue-router';
import Routes from '@/router/routes';
import httpClient from '@/services/http-client';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: Routes
});

router.beforeEach(async (to, from, next) => {
  Vue.prototype.$showNavigationLoading();
  httpClient.cancelPendingRequests();
  next();
});

router.onError(() => {
  Vue.prototype.$hideNavigationLoading();
});

router.afterEach((to: any) => {
  Vue.prototype.$hideNavigationLoading();

  document.title = to.meta.title ? `${to.meta.title} | تالیا` : 'تالیا';
});

export default router;
